export default __webpack_public_path__ + "static/media/image.athlan-pvt-ltd.a2ae7fc9.png";